var _defs, _path, _g, _path2, _ellipse, _rect, _path3, _path4, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2ca0ff;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-4{fill:#fff;}.cls-5{fill:#56c1fc;}.cls-6{fill:#f5f1e5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.05,479.31l149.21,61.28a82.67,82.67,0,0,0,58.37,1.68l695.28-239.63c53.35-18.39,112.11,8.8,131.59,61.76.38,1,.75,2.07,1.12,3.11s.72,2.12,1.07,3.17c17.77,54.11-11.9,112.42-65.74,131L511.11,746.31a82.76,82.76,0,0,0-39.74,29.27l-81.1,110.56Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.05,479.31l149.21,61.28a82.67,82.67,0,0,0,58.37,1.68l695.28-239.63c53.35-18.39,112.11,8.8,131.59,61.76.38,1,.75,2.07,1.12,3.11s.72,2.12,1.07,3.17c17.77,54.11-11.9,112.42-65.74,131L511.11,746.31a82.76,82.76,0,0,0-39.74,29.27l-81.1,110.56Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 530.01,
    y1: 540,
    x2: 992.27,
    y2: 381.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1194.52,337.51c4.53.77,33.52,6.16,49.52,32.84,14.15,23.58,12.53,54.43-4.12,78.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1116.08,338.83a106.19,106.19,0,0,0-28.74,10.41c-2.06,1.1-4.23,2.46-5,4.67-1.44,4.2,3.5,8.21,7.93,8.07s8.35-2.77,12.44-4.47,9.42-2.27,12.46,1c2.39,2.56,2.41,6.56,1.52,9.95s-2.54,6.59-3,10.07c-1.07,8.09,5.85,16.49,14,16.51s15.21-8.91,12.86-16.74c-1.23-4.09-4.49-8.5-2.2-12.11,2-3.2,6.93-2.77,10.3-1s6.45,4.46,10.24,4.73c6.45.46,11.27-7.06,10.12-13.41s-6.39-11.21-12-14.5c-17.11-10.1-40.14-9.06-56.28,2.53"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200.84,496.27l49.21-17A472.92,472.92,0,0,1,370.31,668.69a472.85,472.85,0,0,1,20,217.45l-54,18.61A46,46,0,0,1,288.89,894a417.94,417.94,0,0,1-98.44-153c-31.4-85.78-27.28-162.52-20.09-208.53A45.89,45.89,0,0,1,200.84,496.27Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 267.28,
    cy: 704.2,
    rx: 62.86,
    ry: 199.16,
    transform: "translate(-214.87 125.53) rotate(-19.02)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 528.68,
    y: 590.25,
    width: 147.17,
    height: 52.29,
    rx: 25.49,
    transform: "translate(-167.98 229.89) rotate(-19.02)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M562.12,618.42l41-13.56a10.89,10.89,0,0,1,13.68,6.69l.05.13a10.89,10.89,0,0,1-6.87,14l-41,13.43a10.9,10.9,0,0,1-13.63-6.65h0A10.9,10.9,0,0,1,562.12,618.42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.55,557.53S395,647.06,395,817.66"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 259.38,
    cy: 706.92,
    rx: 22.7,
    ry: 55.18,
    transform: "matrix(0.97, -0.25, 0.25, 0.97, -168.85, 87.54)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects10);
export default __webpack_public_path__ + "static/media/objects-10.97c040d561bb7d4ab7cf74e8da075d9d.svg";
export { ForwardRef as ReactComponent };